/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import ReducerIndex from 'qwc2/reducers/index';
import indicatorsReducer from '../reducers/indicators';
import {LayerRole, removeLayer, addLayerFeatures} from "qwc2/actions/layers";
import isEmpty from 'lodash.isempty';

ReducerIndex.register("indicators", indicatorsReducer);

export const INDICATORS_LOADED = 'INDICATORS_LOADED';
export const SET_INDICATORS = 'SET_INDICATORS';
export const SELECT_INDICATOR = 'SELECT_INDICATOR';
export const ADD_FOR_INDICATORS = 'ADD_FOR_INDICATORS';
export const REMOVE_FOR_INDICATORS = 'REMOVE_FOR_INDICATORS';
export const RESET_FOR_INDICATORS = 'RESET_FOR_INDICATORS';
export const ADD_ADDINDICATORS = 'ADD_ADDINDICATORS';
export const REMOVE_ADDINDICATORS = 'REMOVE_ADDINDICATORS';
export const RESET_ADDINDICATORS = 'RESET_ADDINDICATORS';
export const RESET_COMPAREINDICATOR = 'RESET_COMPAREINDICATOR';
export const SELECT_COMPAREINDICATOR = 'SELECT_COMPAREINDICATOR';

export function selectCompareIndicator(indicator) {
    return {
        type: SELECT_COMPAREINDICATOR,
        indicator
    };
}

export function resetCompareIndicator() {
    return {
        type: RESET_COMPAREINDICATOR
    };
}

export function addAdditionalIndicator(indicator) {
    return {
        type: ADD_ADDINDICATORS,
        indicator
    };
}

export function removeAdditionalIndicator(indicator) {
    return {
        type: REMOVE_ADDINDICATORS,
        indicator
    };
}

export function resetAdditionalIndicators() {
    return {
        type: RESET_ADDINDICATORS
    };
}

export function addForIndicators(object) {
    return {
        type: ADD_FOR_INDICATORS,
        object
    };
}

export function removeForIndicators(object) {
    return {
        type: REMOVE_FOR_INDICATORS,
        object
    };
}

export function resetForIndicators() {
    return {
        type: RESET_FOR_INDICATORS
    };
}

export function setIndicators(indicators) {
    return {
        type: SET_INDICATORS,
        indicators
    };
}

export function selectIndicator(indicator, objectType, date) {
    return {
        type: SELECT_INDICATOR,
        indicator,
        objectType,
        date,
    };
}

export function indicatorsLoaded(indicators) {
    return {
        type: INDICATORS_LOADED,
        indicators
    };
}

export function highlightSelected() {
    return (dispatch, getState) => {
        dispatch(removeLayer("identifyslection2"));
        const features = [];
        getState().indicators.selectedObjects.forEach(so => {
            const item = so.linkedObject;
            if (item && item.geometry) {
                // copy, the item belongs to the redux state and must not be modified
                features.push({...item, crs: 'EPSG:4326'});
            }
        });
        if (features.length > 0) {
            const layer = {
                id: "identifyslection2",
                role: LayerRole.SELECTION
            };
            dispatch(addLayerFeatures(layer, features, true));
        }
    };
}


